import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { GrispiInputProps } from '..';
import { useCompanyPhoneCountryAndPlaceholder } from '../../../hooks/usePhoneCountryAndPlaceholder';
import GrispiInputContainer from '../GrispiInputContainer';
type GrispiPhoneInputProps = Omit<GrispiInputProps<'PHONE'>, 'type' | 'options' | 'isNewValueAllowed'>;

const GrispiPhoneInput = ({ antdProps, containerProps, onChange, value, ...rest }: GrispiPhoneInputProps) => {
    const { phoneCountry, phonePlaceHolder, changePlaceHolderByCountryCode } = useCompanyPhoneCountryAndPlaceholder();

    return (
        <GrispiInputContainer {...containerProps}>
            <PhoneInput
                {...antdProps}
                value={value}
                onChange={onChange}
                defaultCountry={phoneCountry}
                placeholder={phonePlaceHolder}
                numberInputProps={{
                    className: 'grispi-phone-input'
                }}
                onCountryChange={changePlaceHolderByCountryCode}
                {...rest}
            />
        </GrispiInputContainer>
    );
};

export default GrispiPhoneInput;
